document.addEventListener('DOMContentLoaded', () => {
  const quantityUpsellEls = document.querySelectorAll('.quantity-upsell [data-quantity]');

  quantityUpsellEls.forEach((quantityUpsell) => {
    quantityUpsell.addEventListener('click', (event) => {
      const quantity = event?.target?.dataset?.quantity;
      const quantityEl = document.querySelector('[action*="cart/add"] [name="quantity"]');

      if (quantity && quantityEl) {
        quantityEl.value = quantity;
        quantityEl.dispatchEvent(new Event('input'));
      }

      const atc = document.querySelector('#teeAtcButton, [action*="cart/add"] [type="submit"]');

      if (atc) {
        atc.scrollIntoView({ behavior: 'smooth', block: 'end' });
        setTimeout(() => {
          atc.click();
        }, 200);
      }
    });
  });
});


/* ====== Custom Empire: Extra Personalize panels for Buy 2 / Buy 3 ====== */
/* ====== HOW TO ADD A NEW PRODUCT ======================================
   1. Find the product's URL handle (the part after /products/ in the URL).
      e.g. "engraved-leather-valet-tray-for-men-light-coffee-baseball-ball"
   2. Inspect the product page in dev tools: find each Teeinblue input that
      has a name starting with "layer-...". Note its layer ID, its property
      label (Shopify shows it in the cart, e.g. "Add Your Name"), and its type
      (text, number, font-radio with image previews, color-swatch radio).
   3. Add a new entry to the PRODUCTS object below, copying the structure
      from one of the existing entries.
   ====================================================================== */
(function () {
  var PRODUCTS = {

    'engraved-leather-valet-tray-for-men-light-coffee-baseball-ball': {
      fields: [
        { kind: 'text',   property: 'Name',                  required: true,  placeholder: 'Type Name' },
        { kind: 'number', property: 'Number',                required: true,  placeholder: 'add number', max: 999 },
        { kind: 'toggle-text',
          property: 'Add Personalized Text',
          toggleLabel: 'Bottom Text ($4.90)',
          textProperty: 'Bottom Text',
          textPlaceholder: '40 character limit',
          textMaxLength: 40,
          // For item #1, the bottom-text value lives only in this Teeinblue
          // layer input (Teeinblue doesn't expose it as a properties[*] field)
          item1TextLayer: 'layer-276887',
          item1ToggleLayer: 'layer-269587'
        },
      ],
    },

    'products-personalized-baby-sports-bag-name': {
      fields: [
        { kind: 'text', property: 'Add Your Name', required: true, placeholder: 'Noah / Liam' },
        { kind: 'image-radio',
          property: 'Choose Font',
          options: [
            { label: 'Chewy',  value: 'Chewy-Regular',
              image: 'https://cdn.teeinblue.com/users/45944/cliparts/2413713/69f2bd75a6263_thumbnail.webp' },
            { label: 'Disney', value: 'Disney',
              image: 'https://cdn.teeinblue.com/users/45944/cliparts/2413713/69f2c3c270c44_thumbnail.webp' },
          ],
        },
        { kind: 'color-swatch',
          property: 'Choose Thread Color',
          options: [
            { label: 'White',     value: 'white',   swatch: '#ffffff', border: true },
            { label: 'Black',     value: 'black',   swatch: '#000000' },
            { label: 'Silver',    value: 'silver',  swatch: '#c0c0c0' },
            { label: 'Green',     value: 'green',   swatch: '#2e8b57' },
            { label: 'Navy',      value: 'navy',    swatch: '#001f3f' },
            { label: 'Orange',    value: 'orange',  swatch: '#ff851b' },
            { label: 'Gold',      value: 'gold',    swatch: '#d4af37' },
            { label: 'Baby Blue', value: '#89CFF0', swatch: '#89CFF0' },
          ],
        },
      ],
    },

  };

  function getCurrentProductHandle() {
    var path = location.pathname.split('?')[0];
    var m = path.match(/\/products\/([^\/]+)/);
    return m ? m[1] : null;
  }

  function init() {
    var handle = getCurrentProductHandle();
    var config = handle && PRODUCTS[handle];
    if (!config) return; // not a product we've configured

    var tierCards = document.querySelectorAll('.ce-upsell__card');
    if (!tierCards.length) return;

    var atcForm = (function () {
      var forms = document.querySelectorAll('form[action="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[type="submit"]') && forms[i].querySelector('input[name="quantity"]')) {
          return forms[i];
        }
      }
      return forms[0] || null;
    })();
    if (!atcForm) return;

    var teeWrapper =
      document.getElementById('tee-artwork-form') ||
      document.getElementById('teeinblue-form') ||
      document.querySelector('.tee-form-wrapper');
    if (!teeWrapper) return;

    var extraWrap = document.getElementById('ce-extra-personalize-wrap');
    if (!extraWrap) {
      extraWrap = document.createElement('div');
      extraWrap.id = 'ce-extra-personalize-wrap';
      teeWrapper.parentNode.insertBefore(extraWrap, teeWrapper.nextSibling);
    }

    function fieldHTML(field, panelIndex) {
      var safeId = 'ce-' + panelIndex + '-' + field.property.replace(/\s+/g, '-');
      if (field.kind === 'text') {
        return '<div class="ce-row">' +
          '<label class="ce-label">' + field.property + '</label>' +
          '<input type="text" data-prop="' + field.property + '" placeholder="' + (field.placeholder || '') + '" maxlength="' + (field.maxLength || 40) + '">' +
          '</div>';
      }
      if (field.kind === 'number') {
        return '<div class="ce-row">' +
          '<label class="ce-label">' + field.property + '</label>' +
          '<input type="number" data-prop="' + field.property + '" placeholder="' + (field.placeholder || '') + '" min="0" max="' + (field.max || 999) + '">' +
          '</div>';
      }
      if (field.kind === 'image-radio') {
        var opts = field.options.map(function (o, i) {
          return '<label class="ce-img-option">' +
            '<input type="radio" name="' + safeId + '" value="' + o.value + '"' + (i === 0 ? ' checked' : '') + '>' +
            '<span class="ce-img-tile"><img src="' + o.image + '" alt="' + o.label + '"><em>' + o.label + '</em></span>' +
          '</label>';
        }).join('');
        return '<div class="ce-row" data-prop="' + field.property + '" data-kind="image-radio">' +
          '<label class="ce-label">' + field.property + '</label>' +
          '<div class="ce-img-row">' + opts + '</div>' +
          '</div>';
      }
      if (field.kind === 'color-swatch') {
        var opts2 = field.options.map(function (o, i) {
          return '<label class="ce-swatch" title="' + o.label + '">' +
            '<input type="radio" name="' + safeId + '" value="' + o.value + '"' + (i === 0 ? ' checked' : '') + '>' +
            '<span class="ce-swatch-dot' + (o.border ? ' ce-swatch-dot--border' : '') + '" style="background:' + o.swatch + '"></span>' +
          '</label>';
        }).join('');
        return '<div class="ce-row" data-prop="' + field.property + '" data-kind="color-swatch">' +
          '<label class="ce-label">' + field.property + '</label>' +
          '<div class="ce-swatch-row">' + opts2 + '</div>' +
          '</div>';
      }
      if (field.kind === 'toggle-text') {
        return '<div class="ce-row" data-kind="toggle-text" data-property="' + field.property + '" data-text-property="' + field.textProperty + '">' +
          '<label class="ce-label">' + field.property + '</label>' +
          '<div class="ce-options">' +
            '<label><input type="radio" name="' + safeId + '" value="" checked> None</label>' +
            '<label><input type="radio" name="' + safeId + '" value="' + field.toggleLabel + '"> ' + field.toggleLabel + '</label>' +
          '</div>' +
          '<div class="ce-row ce-bottom-text-row" style="display:none;margin-top:10px;">' +
            '<label class="ce-label">Add Your Text</label>' +
            '<input type="text" data-prop="' + field.textProperty + '" placeholder="' + (field.textPlaceholder || '') + '" maxlength="' + (field.textMaxLength || 40) + '">' +
          '</div>' +
        '</div>';
      }
      return '';
    }

    function buildPanel(index) {
      var panel = document.createElement('div');
      panel.className = 'ce-extra-personalize';
      panel.setAttribute('data-item-index', String(index));
      var html = '<h3>Personalize item #' + index + '</h3>';
      config.fields.forEach(function (f) { html += fieldHTML(f, index); });
      html += '<div class="ce-error">Please fill in all required fields for this item.</div>';
      panel.innerHTML = html;

      // Wire up toggle-text behaviour
      panel.querySelectorAll('[data-kind="toggle-text"]').forEach(function (row) {
        row.addEventListener('change', function (ev) {
          if (ev.target.type !== 'radio') return;
          var textRow = row.querySelector('.ce-bottom-text-row');
          if (!textRow) return;
          textRow.style.display = ev.target.value ? '' : 'none';
          if (!ev.target.value) textRow.querySelector('input').value = '';
        });
      });
      return panel;
    }

    function renderPanels(qty) {
      window.__ceSelectedQty = qty;
      extraWrap.innerHTML = '';
      for (var i = 2; i <= qty; i++) extraWrap.appendChild(buildPanel(i));
    }

    tierCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var q = parseInt(card.getAttribute('data-quantity') || '1', 10);
        renderPanels(q);
      });
    });

    var selectedCard = document.querySelector('.ce-upsell__card.is-selected');
    var initialQty = selectedCard ? parseInt(selectedCard.getAttribute('data-quantity') || '1', 10) : 1;
    renderPanels(initialQty);

    atcForm.addEventListener('submit', function (ev) {
      var qty = window.__ceSelectedQty || 1;
      if (qty < 2) return;

      ev.preventDefault();
      ev.stopPropagation();

      var panels = extraWrap.querySelectorAll('.ce-extra-personalize');

      // Validate required fields
      var ok = true;
      panels.forEach(function (p) {
        var bad = false;
        config.fields.forEach(function (f) {
          if (!f.required) return;
          var inp = p.querySelector('input[data-prop="' + f.property + '"]');
          if (inp && !inp.value.trim()) bad = true;
        });
        if (bad) { p.classList.add('ce-has-error'); ok = false; }
        else p.classList.remove('ce-has-error');
      });
      if (!ok) {
        var firstBad = extraWrap.querySelector('.ce-has-error');
        if (firstBad) firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var variantId = atcForm.querySelector('input[name="id"]').value;

      // Base props (item #1) come from the existing Teeinblue hidden inputs
      var baseProps = {};
      atcForm.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(function (inp) {
        var m = inp.name.match(/properties\[(.+)\]/);
        if (m && inp.value) baseProps[m[1]] = inp.value;
      });

      // For any toggle-text field, also pull item #1's hidden bottom-text value
      config.fields.forEach(function (f) {
        if (f.kind !== 'toggle-text') return;
        var toggle = f.item1ToggleLayer ? document.querySelector('input[name="' + f.item1ToggleLayer + '"]:checked') : null;
        var textInp = f.item1TextLayer ? document.querySelector('input[name="' + f.item1TextLayer + '"]') : null;
        if (toggle && textInp && textInp.value.trim()) {
          baseProps[f.textProperty] = textInp.value.trim();
        }
      });

      baseProps['Item #'] = '1';

      var items = [{ id: variantId, quantity: 1, properties: Object.assign({}, baseProps) }];

      panels.forEach(function (p, idx) {
        var itemNo = idx + 2;
        var props = Object.assign({}, baseProps);

        config.fields.forEach(function (f) {
          if (f.kind === 'text' || f.kind === 'number') {
            var inp = p.querySelector('input[data-prop="' + f.property + '"]');
            if (inp) props[f.property] = inp.value.trim();
          } else if (f.kind === 'image-radio' || f.kind === 'color-swatch') {
            var row = p.querySelector('[data-prop="' + f.property + '"]');
            var sel = row && row.querySelector('input[type="radio"]:checked');
            if (sel) props[f.property] = sel.value;
          } else if (f.kind === 'toggle-text') {
            var row2 = p.querySelector('[data-kind="toggle-text"]');
            var sel2 = row2 && row2.querySelector('input[type="radio"]:checked');
            var textInp = row2 && row2.querySelector('input[data-prop="' + f.textProperty + '"]');
            if (sel2 && sel2.value) {
              props[f.property] = sel2.value;
              if (textInp && textInp.value.trim()) props[f.textProperty] = textInp.value.trim();
            } else {
              delete props[f.property];
              delete props[f.textProperty];
            }
          }
        });

        props['Item #'] = String(itemNo);
        items.push({ id: variantId, quantity: 1, properties: props });
      });

      var submitBtn = atcForm.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('[CE multi-add]', err);
          alert('Sorry, something went wrong adding the items to your cart. Please try again.');
          if (submitBtn) submitBtn.disabled = false;
        });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();